import React from 'react';
import Loadable from 'react-loadable';
import Loading from 'react-loading-animation';

const ReviewDialogLoadable = Loadable({
  loader: () => import('./ReviewDialog')
    .then(module => module.default)
    .catch(e => { console.log(e); if (window) window.location.reload(); }),
  loading: () => <div key="ReviewDialogLoadableLoading"><Loading /></div>
});

export default ReviewDialogLoadable;
